/* ============================================================
   Lo ultimo que ha visto el cliente.

   Dos trabajos:
   1. En cada ficha de producto, apuntar el handle en el navegador.
   2. En el carrito vacio, sustituir los productos de respaldo por los
      que esa persona acaba de mirar.

   Se guarda en localStorage y no sale de su navegador: no viaja al
   servidor ni se comparte entre dispositivos. Si el navegador lo tiene
   bloqueado -modo privado, cookies restringidas- todo sigue funcionando
   y el carrito ensena el respaldo que ya pinta Liquid.
   ============================================================ */

(function () {
  var CLAVE = 'cs_vistos';
  var MAXIMO = 12;
  var CUANTOS = 3;

  function leer() {
    try {
      var v = JSON.parse(localStorage.getItem(CLAVE));
      return Object.prototype.toString.call(v) === '[object Array]' ? v : [];
    } catch (e) {
      return [];
    }
  }

  function guardar(lista) {
    try {
      localStorage.setItem(CLAVE, JSON.stringify(lista));
    } catch (e) { /* sin almacenamiento, no se apunta nada */ }
  }

  function raiz() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  /* ---------- 1. Apuntar la ficha que se esta viendo ---------- */
  var marca = document.querySelector('[data-pp3-producto]');
  if (marca) {
    var handle = marca.getAttribute('data-pp3-producto');
    if (handle) {
      var lista = leer().filter(function (h) { return h !== handle; });
      lista.unshift(handle);
      guardar(lista.slice(0, MAXIMO));
    }
  }

  /* ---------- 2. Rellenar el carrito vacio ---------- */
  function dinero(centimos, formato) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      try { return Shopify.formatMoney(centimos, formato); } catch (e) { /* sigue abajo */ }
    }
    return (centimos / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function conAncho(url, ancho) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + ancho;
  }

  function escapa(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/"/g, '&quot;')
      .replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function tarjeta(p, formato, accion) {
    var url = raiz().replace(/\/$/, '') + '/products/' + p.handle;
    var foto = conAncho(p.featured_image || (p.images && p.images[0]), 400);

    // El + repite el marcado del boton del tema para que lo recoja su
    // propio delegado: asi abre la ventana rapida igual que en el resto
    // de tarjetas, sin duplicar esa logica aqui.
    var mas = accion === 'popup'
      ? '<button class="f-product-form sf-pqv__button sf__btn sf__btn-secondary sf__btn-white flex-grow"' +
        ' data-product-url="' + escapa(url) + '"' +
        ' data-product-id="' + escapa(p.id) + '"' +
        ' data-product-handle="' + escapa(p.handle) + '"><span>+</span></button>'
      : '<a class="f-product-form sf__btn sf__btn-secondary sf__btn-white flex-grow" href="' + escapa(url) + '"><span>+</span></a>';

    return '<article class="pc3-sug__item">' +
      '<div class="pc3-sug__media">' +
        '<a class="pc3-sug__link" href="' + escapa(url) + '" aria-label="' + escapa(p.title) + '">' +
          (foto ? '<img class="pc3-sug__img" src="' + escapa(foto) + '" alt="' + escapa(p.title) + '" loading="lazy">' : '') +
        '</a>' +
        '<div class="sf__pcard-quick-add">' + mas + '</div>' +
      '</div>' +
      '<a class="pc3-sug__name" href="' + escapa(url) + '">' + escapa(p.title) + '</a>' +
      '<span class="pc3-sug__price">' + dinero(p.price, formato) + '</span>' +
    '</article>';
  }

  function rellenar() {
    var caja = document.querySelector('.pc3-sug[data-vistos]');
    if (!caja || caja.dataset.pp3Hecho) return;

    var handles = leer().slice(0, CUANTOS);
    if (!handles.length) return; // sin historial se queda el respaldo

    caja.dataset.pp3Hecho = '1';
    var formato = caja.getAttribute('data-money') || '';
    var accion = caja.getAttribute('data-accion') || 'popup';

    Promise.all(handles.map(function (h) {
      return fetch(raiz().replace(/\/$/, '') + '/products/' + h + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (productos) {
      var vivos = productos.filter(Boolean);
      if (!vivos.length) return; // se han despublicado: mejor el respaldo

      var rejilla = caja.querySelector('.pc3-sug__grid');
      if (!rejilla) return;
      rejilla.innerHTML = vivos.map(function (p) { return tarjeta(p, formato, accion); }).join('');

    });
  }

  window.pp3Vistos = rellenar;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', rellenar);
  } else {
    rellenar();
  }

  // El cajon se repinta al cambiar el carrito y al abrirlo: la tarjeta
  // nueva tiene que volver a llenarse.
  document.addEventListener('click', function () {
    setTimeout(rellenar, 700);
  }, true);
})();
